import { useMemo } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { getGetCardQueryOptions, useUpdateLinker } from './artemy/client';
import type {
  CardId, UpdateLinkerBodyAction, ListId, UpdateLinker207,
} from './artemy/model';

interface UseCardListLinkerProps {
  action: UpdateLinkerBodyAction;
  cardIds: CardId[];
  listId: ListId;
  onSuccess?: VoidFunction;
}
function useCardListLinkerPoint3({
  action,
  cardIds,
  listId,
  onSuccess = undefined,
}: UseCardListLinkerProps): () => Promise<void | UpdateLinker207> {
  const queryClient = useQueryClient();
  const linker = useUpdateLinker({
    mutation: {
      onSuccess: () => {
        cardIds.forEach((cardId) => {
          queryClient.invalidateQueries(getGetCardQueryOptions(cardId));
        });
        onSuccess?.();
      },
    },
  });

  return useMemo(
    () => async () => linker.mutateAsync({
      data: {
        list_id: listId,
        card_ids: cardIds,
        action,
      },
    }),
    [linker, listId, cardIds, action],
  );
}
export { useCardListLinkerPoint3 };
